import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Helper} from './classes/helpers/helper';
import {Language, Languages} from './language';
import {environment} from "../../environments/environment";

@Injectable({
	providedIn: 'root',
})
export class LanguageService {

	private currentLanguage: Language | null;

	constructor(
		private translateService: TranslateService,
		private window: Window,
		private router: Router,
		@Inject(DOCUMENT) private document: Document,
	) {
		this.currentLanguage = null;

		// Declare the real page language so browsers don't offer to machine-translate the portal.
		this.translateService.onLangChange.subscribe(event => {
			this.document.documentElement.lang = event.lang;
		});
	}

	getCurrentLanguage(): Language {
		if (this.currentLanguage !== null) {
			return this.currentLanguage;
		}
		const pathName = this.window.location.pathname;
		const languageKey = pathName.slice(1, 3);

		switch (languageKey) {
			case 'en':
				this.currentLanguage = Language.English;
				break;
			case 'bg':
				this.currentLanguage = Language.Bulgarian;
				break;
			default:
				const defaultLanguage = environment.defaultLanguage as Language;
				this.router.navigate([`/${defaultLanguage}`]).finally();
				this.currentLanguage = defaultLanguage;
				break;
		}

		return this.currentLanguage;
	}

	reset(): void {
		this.currentLanguage = null;
		this.translateService.use(this.getCurrentLanguage());
	}

	register(): void {
		this.translateService.addLangs(Languages);
		this.translateService.setDefaultLang(Language.English);
		this.translateService.use(this.getCurrentLanguage());
	}

	getInstantTranslationByKey(key: string): string {
		return this.translateService.instant(key);
	}
}
